import { Component } from '@angular/core';
import { UsuarioService } from '@account/usuario.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';
import { TipoDocumento } from '@shared/enums/tipoDocumento';
import { SaldoCliente, SolicitudCreditoDTO } from '@shared/models/controlCredito/SaldoCliente';
import { ControlCreditoService } from '../../control-credito.service';
import { FormControl } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from '@shell/message.service';
import { ErrorModel } from '@shared/models/ErrorModel';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EstadoCliente } from '@shared/enums/EstadoCliente';
import { NotificacionesService } from '@abm/notificacion/notificaciones.service';
import { Comercial } from '@shared/models/controlCredito/Comercial';
import { AuthService } from '@authentication/auth.service';
import { switchMap, tap } from "rxjs/operators";
import { TipoReporte } from "@shared/enums/tipoReporte";
import { ActivatedRoute } from "@angular/router";
import { Guid } from 'guid-typescript';
import { EstadoFiltro } from "@shared/enums/EstadoFiltro";
import { FiltroReporteSaldo } from "@shared/models/controlCredito/FiltroReporteSaldo";
import { UsuarioDTO } from "@shared/models/notificaciones";
import { ModalConfirmComponent } from "@shared/generic-modals/modal-confirm.component";
import { AccionEliminar } from "@shared/enums/AccionEliminar";
import { AccionSolicitud } from "@shared/enums/AccionSolicitud";
import { ModalReporteAerovalesComponent } from "@controlCredito/reportes/modales/modal-reporte-aerovales/modal-reporte-aerovales.component";
import { SolicitudCliente } from "@shared/models/controlCredito/SolicitudCliente";
import { ExportExcelServiceService } from "@shared/exportar-excel/export-excel-service.service";
import { DecimalPipe } from "@angular/common";
import { EstadoSolicitudCrediticia } from "@shared/enums/EstadoSolicitudCrediticia";

@Component({
  selector: 'app-reporte-saldos',
  templateUrl: './reporte-saldos.component.html',
  styleUrls: ['./reporte-saldos.component.scss']
})
export class ReporteSaldosComponent {

  accionEliminar = AccionEliminar;
  saldoClientes: SaldoCliente[];
  solapaReporte: number;
  comercialesFiltros = [];
  ejecutivosFiltros = [];
  saldosFiltrados: SaldoCliente[] = [];
  tipoDocumento = TipoDocumento;
  busquedaFormControl = new FormControl();
  obteniendoSaldosScroll: boolean = false;
  ocultarTabla: boolean = false;
  throttle: number = 500;
  distance: number = 2;
  page: number = 0;
  pageSize: number = 20;
  filtrando: boolean;
  jsonFiltros: FiltroReporteSaldo = new FiltroReporteSaldo();
  clickeado: string;
  EstadoCliente = EstadoCliente;
  bloquear: boolean = false;
  descargandoClientes: boolean = false;
  accionEnProceso?: AccionSolicitud;
  actualiza: boolean = false;
  idNotificacionSaldos: string;
  excedidoFiltro: boolean = false;
  seleccionado: number;
  TipoUsuario = TipoUsuario;
  stopScroll: boolean;
  cargandoPendiente: boolean[][] = [];
  cargandoNotificacion: boolean[];
  cargandoConfiguracion: boolean[];
  scrollActivo: boolean = true;
  TipoReporte = TipoReporte;
  checkArray: string[] = [];
  cargandoPad: boolean = false;
  EstadosFiltros :EstadoFiltro[] = Object.values(EstadoFiltro).filter(v => typeof v === 'number') as EstadoFiltro[];
  selecciones = new Map<EstadoFiltro, boolean>();
  enumAccionSolicitud = AccionSolicitud;
  bloquearPendiente: boolean = false;
  bloquearActualizar: boolean = false;

  constructor(private controlCreditoService: ControlCreditoService, public authService: AuthService,
              private usuarioService: UsuarioService, private spinner: NgxSpinnerService, private route: ActivatedRoute,
              private messageService: MessageService, private modal: NgbModal, private modalService: NgbModal,
              private notificacionesService: NotificacionesService, private excelService: ExportExcelServiceService,
              public decimalPipe: DecimalPipe) {
    this.route.queryParams.pipe(
      tap(params => {
        this.solapaReporte= params['solapaReporte'] ? Number(params['solapaReporte']) : this.TipoReporte.reporteSaldo;
        this.page = 0;
        this.bloquear = true;
        this.busqueda.setValue('');
        this.getComerciales();
        this.getEjecutivos();
        this.initRequest(false);
        this.getTipoNovedad();
        this.EstadosFiltros.forEach(estado =>
          this.selecciones.set(estado, false)
        );
      }),
      switchMap(() => {
        return this.obtenerReporteConFiltro();
      })
    ).subscribe(result => {
      this.cargandoPendiente = new Array(result.length)
        .fill(0)
        .map(() => [false, false]);
      this.cargandoNotificacion = new Array(result.length).fill(false);
      this.cargandoConfiguracion = new Array(result.length).fill(false);
      this.saldoClientes = result;
      this.saldosFiltrados = this.saldoClientes;
      this.bloquear = false;
      this.ocultarSpinner();
      this.procesarResult(result, false);
    }, (err: ErrorModel) => {
      this.procesarError(err, false);
    });
  }

  mostrarSpinner(){
    this.ocultarTabla = true;
    this.spinner.show('spinnerLista');
  }

  ocultarSpinner(){
    this.ocultarTabla = false;
    this.spinner.hide('spinnerLista');
  }

  obtenerReporteConFiltro() {
    if (this.page === 0){
      this.jsonFiltros.estados = [];
      this.jsonFiltros.comerciales = [];
      this.jsonFiltros.ejecutivos = [];
      this.jsonFiltros.filtroTexto = "";
      this.jsonFiltros.usuario = this.solapaReporte === TipoReporte.reporteSaldo ? null : this.obtenerUsuario();
      this.jsonFiltros.esAprobador = this.solapaReporte === TipoReporte.reporteAprobador;
    }
    return this.controlCreditoService.getSaldosFiltro(this.jsonFiltros, this.page, this.pageSize, this.busqueda.value);
  }

  // Función para obtener el nombre del estado
  obtenerEtiqueta(estado: EstadoFiltro): string {
    return EstadoFiltro[estado]
      .replace('ExcedidoVencido', 'Excedido y Vencido');
  }

  initRequest(isScroll: boolean) {// eslint-disable-line
    if( !isScroll ){
      this.mostrarSpinner();
    }else{
      this.mostrarSpinnerScroll();
    }
  }

  mostrarSpinnerScroll() {
    this.obteniendoSaldosScroll = true;
  }

  ocultarSpinnerScroll() {
    this.obteniendoSaldosScroll = false;
  }

  procesarResult(saldos, isScroll: boolean) {
    saldos?.length==0 ? this.stopScroll=true : this.stopScroll=false;
    console.log('stop scrolling: ', this.stopScroll);
    if (!isScroll) {
      this.saldoClientes = saldos;
      this.saldosFiltrados = saldos;
      this.ocultarSpinner();
    } else {
      this.saldosFiltrados ? this.saldosFiltrados = this.saldosFiltrados.concat(saldos) : this.saldosFiltrados = saldos;
      if (this.saldosFiltrados){
        this.cargandoPendiente = new Array(this.saldosFiltrados.length)
          .fill(0)
          .map(() => [false, false]);
      }
      this.ocultarSpinnerScroll();
    }
  }

  procesarError(error, isScroll: boolean) {
    if (!isScroll) {
      this.messageService.showErrorMessage('Hubo un error al obtener los datos. ' + error.description);
      this.ocultarSpinner();
    } else if (isScroll) {
      this.messageService.showErrorMessage('Hubo un error al obtener los datos en el scroll. ' + error.description);
      this.ocultarSpinnerScroll();
    }
  }

  onScroll(scrollActivo: boolean){
    if (!scrollActivo) this.page = 1;
    this.initRequest(scrollActivo);
    scrollActivo ? ++this.page : this.page;

    this.obtenerReporteConFiltro().subscribe(
      res => this.procesarResult(res, scrollActivo),
      (err: ErrorModel) => this.procesarError(err, scrollActivo)
    )

  }

  getSaldosConFiltros() {
    this.stopScroll = false;
    this.filtrando = true;
    this.bloquear = true;
    this.mostrarSpinner();
    this.page = 0;
    const comerciales: Comercial[] = [];
    const ejecutivos: UsuarioDTO[] = [];

    this.comercialesFiltros.forEach(comercial => {
      if(!comercial.email) comercial.email = '';
      if(!comercial.nombresCompletos) comercial.nombresCompletos = '';
      if (comercial.seleccionado) comerciales.push({email: comercial.email, nombreCompleto: comercial.nombresCompletos});
    });

    this.ejecutivosFiltros.forEach(ejecutivo => {
      if (ejecutivo.seleccionado && ejecutivo.id) ejecutivos.push(ejecutivo);
    });

    const estados = Array.from(this.selecciones)
      .filter((entrada) => entrada[1]) // entrada[1] es el valor booleano
      .map((entrada) => entrada[0]);

      this.jsonFiltros.estados = estados;
      this.jsonFiltros.comerciales = comerciales;
      this.jsonFiltros.ejecutivos = ejecutivos;
      this.jsonFiltros.filtroTexto = this.busqueda.value ?? "";
      this.jsonFiltros.usuario = this.solapaReporte === TipoReporte.reporteSaldo ? null : this.obtenerUsuario();
      this.jsonFiltros.esAprobador = this.solapaReporte === TipoReporte.reporteAprobador;

      this.controlCreditoService.getSaldosFiltro(this.jsonFiltros, this.page, this.pageSize, this.busqueda.value).subscribe(saldos => {
        this.ocultarSpinner();
        this.saldosFiltrados = saldos;
        if (this.solapaReporte === TipoReporte.reporteSolicitante) {
          this.cargandoPendiente = new Array(saldos.length)
            .fill(0)
            .map(() => [false, false]);
        }
        this.bloquear = false;
      }, (err: ErrorModel) => {
        this.messageService.showErrorMessage('Hubo un error al obtener los datos. ' + err.description);
        this.resetFiltros();
        this.bloquear = false;
      });
  }

  resetFiltros() {
    this.filtrando = false;
    this.jsonFiltros = new FiltroReporteSaldo();
    this.excedidoFiltro = false;
    this.comercialesFiltros.forEach(filtro => filtro.seleccionado = false);
    this.ejecutivosFiltros.forEach(ej => ej.seleccionado = false);
    this.EstadosFiltros.forEach(estado => this.selecciones.set(estado, false));
  }

  mostrarDatos(cliente: string) {
    this.clickeado = cliente;
  }

  manejarBloquearPendiente(event: boolean): void {
    this.bloquearPendiente = event;
  }

  manejarBloquearActualizar(event: boolean): void {
    this.bloquearActualizar = event;
  }

  obtenerUsuario() : UsuarioDTO {
    const usuario = {
      id: this.usuarioService.getIdUsuario(),
      nombresCompletos: this.usuarioService.getNombresCompletosUsuario(),
      dni: this.usuarioService.getDniUsuario(),
      userName: this.usuarioService.getUsernameByName(),
      email: this.usuarioService.getEmailUsuario()
    }
    return usuario;
  }

  getComerciales() {
    this.usuarioService.getUsuariosPorRolYAeroplanta(TipoUsuario.COMERCIAL, "", true).subscribe(comerciales => {
      this.comercialesFiltros = [];
      comerciales.sort((a, b)=> (a.nombresCompletos.toUpperCase() > b.nombresCompletos.toUpperCase()) ? 1 : -1);
      comerciales.forEach(comercial => this.comercialesFiltros.push({ ...comercial, seleccionado: false }));
    });
  }

  getEjecutivos() {
    this.usuarioService.getUsuariosPorRolYAeroplanta(TipoUsuario.EJECUTIVOCUENTA, "", false).subscribe(ejecutivos => {
      this.ejecutivosFiltros = [];
      ejecutivos.sort((a, b)=> (a.nombresCompletos.toUpperCase() > b.nombresCompletos.toUpperCase()) ? 1 : -1);
      ejecutivos.forEach(ejecutivo => this.ejecutivosFiltros.push({ ...ejecutivo, seleccionado: false }));
    });
  }

  getTipoNovedad() {
    //mandando 15 trae la lista de novedades donde se encuentra "Saldo"
    this.notificacionesService.getTipoNovedadPorRoles([15]).subscribe(tiposNovedad => {
      const novedadSaldo = tiposNovedad.find(saldo => saldo.descripcion === 'Saldos');
      this.idNotificacionSaldos = novedadSaldo.id;
    })
  }

  botonAprobador(tipoAccion: AccionSolicitud) {
    const bodyAprobador: SolicitudCliente = {
      clientesId: this.checkArray as unknown as Guid[],
      usuarioAprobador: this.obtenerUsuario(),
      accion: tipoAccion
    }
    const modalRef = this.modalService.open(ModalConfirmComponent, { centered: true, backdrop: 'static' });
    modalRef.componentInstance.mensaje = '¿Desea aplicar los cambios?';
    modalRef.componentInstance.titulo = bodyAprobador.accion === AccionSolicitud.Aprobar ? 'Aprobar cambios' : 'Rechazar cambios';
    modalRef.componentInstance.textoSi = 'Aceptar';
    modalRef.componentInstance.textoNo = 'Cancelar';
    modalRef.result.then((result) => {
      if (result === 'Si'){
        this.bloquear = true;
        this.accionEnProceso = tipoAccion;
        this.controlCreditoService.finalizarSolicitud(bodyAprobador)
          .subscribe(() => {
            this.messageService.showSuccessMessage('Cambios realizados correctamente.');
            this.accionEnProceso = undefined;
            this.bloquear = false;
            this.saldosFiltrados = this.saldosFiltrados.filter(cliente =>
              !bodyAprobador.clientesId.includes(cliente.clienteId as unknown as Guid)
            );
            this.checkArray = [];
          }, (err: ErrorModel) => {
            this.messageService.showErrorMessage('La operación no pudo ser completada: ' + err.description);
            this.accionEnProceso = undefined;
            this.bloquear = false;
          })
      }
    }, () => {
      this.bloquear = false;
    });
  }

  checkSeleccionados(): boolean {
    return this.checkArray.length > 0; // Verificamos si hay elementos
  }

  anularAutorizado(i: number, columna: 0 | 1, solicitudesCredito: SolicitudCreditoDTO, enumAccionEliminar: AccionEliminar) {
    const modalRef = this.modalService.open(ModalConfirmComponent, { centered: true, backdrop: 'static' });
    modalRef.componentInstance.mensaje = '¿Desea desactivar el autorizado?';
    modalRef.componentInstance.titulo = 'Desactivar Autorizado';
    modalRef.componentInstance.textoSi = 'Aceptar';
    modalRef.componentInstance.textoNo = 'Cancelar';
    modalRef.result.then((result) => {
      if (result === 'Si'){
        this.bloquear = true;
        this.cargandoPendiente[i][columna] = true;
        const usuarioBody = this.obtenerUsuario();
        this.controlCreditoService.eliminarSolicitud(solicitudesCredito.id, enumAccionEliminar, usuarioBody)
          .subscribe((res:SolicitudCreditoDTO) => {
            console.log(res);
            this.messageService.showSuccessMessage('Solicitud anulada correctamente.');
            const clienteId = this.saldosFiltrados[i]?.clienteId;
            this.saldosFiltrados = this.saldosFiltrados.map(cliente => {
              if (cliente.clienteId === clienteId) {
                if (enumAccionEliminar === AccionEliminar.Excedido) {
                  cliente.situacionExcedido += cliente.excedidoAutorizado;
                  return {
                    ...cliente,
                    excedidoAutorizado: 0
                  };
                } else {
                  cliente.situacionVencido += cliente.vencidoAutorizado;
                  return {
                    ...cliente,
                    vencidoAutorizado: 0
                  };
                }
              }
              return cliente;
            });
            this.bloquear = false;
            this.cargandoPendiente[i][columna] = false;
          }, (err: ErrorModel) => {
            this.messageService.showErrorMessage('No pudo anularse la solicitud: ' + err.description);
            this.bloquear = false;
            this.cargandoPendiente[i][columna] = false;
          })
      }
    }, () => {
      this.bloquear = false;
      this.cargandoPendiente[i][columna] = false;
    });
  }

  verAerovales(cliente, index) {
    this.seleccionado = index
    this.bloquear = true;
    this.cargandoPad = true;
    this.controlCreditoService.getAerovales(cliente.clienteId).subscribe(aerovales => {
      if (aerovales.length > 0) {
        //se transforma la lista de aerovales en un array de productos donde el primer producto de cada aerovale contiene tambien los datos del aerovale, luego se unen los array de productos en uno.
        let aerovalesLista = [];
        const modalRef = this.modal.open(ModalReporteAerovalesComponent, { centered: true, backdrop: 'static', size: 'xl',  windowClass: 'modalPendientePad' });
        aerovales.forEach(aerovale => {
          aerovale.productos = aerovale.nombreProducto ? [{nombreProducto: aerovale.nombreProducto, codigoProducto: aerovale.codigoProducto, unidadMedida: aerovale.unidadMedida, volumenNaturales: aerovale.volumenNaturales}].concat(aerovale.aeroespecialidades) : aerovale.aeroespecialidades;
          if (aerovale.productos.length > 0) {
            aerovale.productos[0].nombreCliente = aerovale.nombreCliente;
            aerovale.productos[0].cuit = aerovale.cuit;
            aerovale.productos[0].aeroplanta = aerovale.aeroplanta;
            aerovale.productos[0].numeroAerovale = aerovale.numeroAerovale;
            aerovale.productos[0].prefijo = aerovale.prefijo;
            aerovale.productos[0].matricula = aerovale.matricula;
            aerovale.productos[0].tipoVuelo = aerovale.tipoVuelo;
            aerovale.productos[0].rancho = aerovale.rancho;
            aerovale.productos[0].monto = aerovale.montoEstimado;
            aerovale.productos[0].tipoMoneda = aerovale.tipoMoneda;
            aerovale.productos[0].cotizacion = aerovale.cotizacion;
            aerovale.productos[0].impuestos = aerovale.totalImpuestos;
          }
          aerovalesLista.push(aerovale.productos)
        });
        aerovalesLista = [].concat(...aerovalesLista);
        console.log(aerovalesLista);
        modalRef.componentInstance.aerovales = aerovalesLista;
        this.cargandoPad = false;
        this.bloquear = false;
        this.seleccionado = null;
      } else {
        this.cargandoPad = false;
        this.bloquear = false;
        this.messageService.showWarningMessage('El cliente no posee aerovales pendientes de facturar', false)
        this.seleccionado = null;
      }
    }, (error:ErrorModel) => {
      this.messageService.showErrorMessage(error.description + " - " + error.message);
      this.cargandoPad = false;
      this.bloquear = false;
      this.seleccionado = null;
    })
  }

  armarListadoExcel(saldos: SaldoCliente[]) {
    const listadoReporteSaldos: { [key: string]: any }[] = [];
    for (const saldo of saldos) {
      const saldoExportar: { [key: string]: any } = {};
      //Utilizo tipado fuerte para que se muestre así en el excel
      saldoExportar.ClienteRazonSocial = saldo.clienteRazonSocial;
      saldoExportar.NumeroDocumento = saldo.clienteCuit;
      saldoExportar.TipoDocumento = this.tipoDocumento[saldo.tipoDocumento];
      saldoExportar.Limite = this.decimalPipe.transform(saldo.limite,'1.0-0');
      saldoExportar.SaldoPAD = this.decimalPipe.transform(saldo.saldoPAD, '1.0-0');
      saldoExportar.Excedido = this.decimalPipe.transform(saldo.excedido,'1.0-0');
      saldoExportar.ExcedidoAutorizado = this.decimalPipe.transform(saldo.excedidoAutorizado, '1.0-0');
      saldoExportar.SituacionExcedido = this.decimalPipe.transform(saldo.situacionExcedido, '1.0-0');
      saldoExportar.SaldoVencido = this.decimalPipe.transform(saldo.saldoVencido,'1.0-0');
      saldoExportar.VencidoAutorizado = this.decimalPipe.transform(saldo.vencidoAutorizado,'1.0-0');
      saldoExportar.SituacionVencido = this.decimalPipe.transform(saldo.situacionVencido,'1.0-0');
      saldoExportar.EstadoCliente = this.EstadoCliente[saldo.ultimoEstadoCliente?.estadoCliente] ?? '';
      saldoExportar.SolicitudCrediticia = saldo.estadoCrediticio;
      saldoExportar.Comercial = (saldo.comerciales || []).join('; ');
      saldoExportar.Ejecutivo = saldo.ejecutivoCuenta?.nombresCompletos ?? '';
      listadoReporteSaldos.push(saldoExportar);
    }
    return listadoReporteSaldos;
  }

  existeSolicitudExcedido(cliente: SaldoCliente): boolean {
    const fechaActual = new Date();
    fechaActual.setHours(0, 0, 0, 0); // Ignorar hora para comparación solo por fecha
    return cliente.solicitudesCrediticias?.some(s => {
      if (s.excedido && s.excedido.fechaHasta && s.estado === EstadoSolicitudCrediticia.Aprobada) {
        const fechaHasta = new Date(s.excedido.fechaHasta);
        return fechaHasta >= fechaActual;
      }
      return false;
    }) ?? false;
  }

  existeSolicitudVencido(cliente: SaldoCliente): boolean {
    const fechaActual = new Date();
    fechaActual.setHours(0, 0, 0, 0); // Ignorar hora para comparación solo por fecha

    return cliente.solicitudesCrediticias?.some(s => {
      if (s.vencido && s.vencido.fechaHasta && s.estado === EstadoSolicitudCrediticia.Aprobada) {
        const fechaHasta = new Date(s.vencido.fechaHasta);
        return fechaHasta >= fechaActual;
      }
      return false;
    }) ?? false;
  }

  getSolicitudExcedido(cliente: SaldoCliente): SolicitudCreditoDTO | undefined {
    return cliente.solicitudesCrediticias?.find(s => s.excedido && s.estado === EstadoSolicitudCrediticia.Aprobada);
  }

  getSolicitudVencido(cliente: SaldoCliente): SolicitudCreditoDTO | undefined {
    return cliente.solicitudesCrediticias?.find(s => s.vencido && s.estado === EstadoSolicitudCrediticia.Aprobada);
  }

  exportarExcel() {
    this.excelService.exportAsExcelFile(this.armarListadoExcel(this.saldosFiltrados), 'ListadoDeSaldoClientes');
  }

  get busqueda() {
    return this.busquedaFormControl;
  }
}
